export enum SubdelegatedRole {
  ADMINISTRATOR = 'ADMINISTRATOR',
  OPERATOR = 'OPERATOR'
}

export type SubdelegatedCheckResponse = {
  inviteCode: string
  email: string
  lpDocument: string
  isCashMember: boolean
  role?: SubdelegatedRole | null
}

export type LegalRepresentativePayload = {
  fullName: string
  cpf: string
  birthDate: string
  email: string
}

export type SubdelegatedRegistrationPayload = {
  fullName: string
  email: string
  phoneNumber: string
  zipCode: string
  lpDocument: string
  corporateName: string
  tradeName: string
  cnae: string
  jointSignature: boolean
  representative1: LegalRepresentativePayload
  representative2?: LegalRepresentativePayload
}

export type SubdelegatedRegistrationResponse = {
  inviteCode: string
  step: string
}

export type SubdelegatedErrorDetail = {
  code: number
  reason: string
  message: string
}

export type SubdelegatedErrorResponse = {
  timestamp: string
  status: number
  error: string
  details: string
  cshTraceId: string
  errors?: SubdelegatedErrorDetail[]
}
